import { render, staticRenderFns } from "./AttendencePlacesDetails.vue?vue&type=template&id=20b9f98c&scoped=true"
import script from "./AttendencePlacesDetails.vue?vue&type=script&lang=js"
export * from "./AttendencePlacesDetails.vue?vue&type=script&lang=js"
import style0 from "./AttendencePlacesDetails.vue?vue&type=style&index=0&id=20b9f98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9f98c",
  null
  
)

export default component.exports